import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser, notifyAuthChanged } from "../../auth";

const navItems = [
  { id: "employee-dashboard", label: "Dashboard", icon: "la la-home", key: "dashboard", to: "/employee-dashboard" },
  { id: "employee-profile", label: "Company Profile", icon: "la la-building", key: "profile", to: "/employee-company-profile" },
  { id: "employee-view-profile", label: "View Profile", icon: "la la-eye", key: "profile-view", to: "/employee-view-company-profile" },
  { id: "employee-post-job", label: "Post a Job", icon: "la la-plus-circle", key: "post-job", to: "/employee-post-job" },
  { id: "employee-manage-jobs", label: "Manage Jobs", icon: "la la-briefcase", key: "manage-jobs", to: "/employee-manage-jobs" },
  { id: "employee-applicants", label: "Applicants", icon: "la la-users", key: "applicants", to: "/employee-applicants" },
  { id: "employee-plans", label: "Plans & Payments", icon: "la la-credit-card", key: "plans", to: "/employee-plans" },
  { id: "employee-logout", label: "Logout", icon: "la la-sign-out", to: "/" },
];

const EmployeeSidebar = ({ active = "dashboard", onClose }) => {
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logoutUser({ notify: false });
    onClose?.();
    navigate("/login", { replace: true });
    notifyAuthChanged();
  };

  return (
    <div className="user-sidebar">
      <div className="sidebar-inner">
        <div className="employee-sidebar-head">
          <div>
            <h4>Employer Menu</h4>
            <span>Manage hiring activity</span>
          </div>
          <button type="button" onClick={onClose} aria-label="Close employer menu">
            &times;
          </button>
        </div>

        <ul className="navigation">
          {navItems.map((item) => (
            <li className={item.key === active ? "active" : ""} key={item.id}>
              <Link to={item.to || "/employee-dashboard"} onClick={item.id === "employee-logout" ? handleLogout : onClose}>
                <i className={item.icon}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="employee-sidebar-note">
          <h4>Need Job Credits?</h4>
          <p>Buy a Single Job Post or Best Value 12-pack before posting new roles.</p>
          <Link to="/employee-plans" onClick={onClose}>Go to Plans & Payments</Link>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSidebar;
